import { marked } from "marked";
import { useMemo } from "react";

export default function MarkdownContent({ content }) {
  const html = useMemo(() => (content ? marked.parse(content) : ""), [content]);

  if (!content) return null;

  return (
    <div className="markdown-content" dangerouslySetInnerHTML={{ __html: html }} />
  );
}
